import { BillListItemDTO, BillsResponseDTO } from "../models/BillDTOs";
import {
  BillListItemEntity,
  BillsResultEntity,
  PaginationInfo,
} from "../../domain/entities/BillListItemEntity";

export class BillMapper {
  static toEntity(dto: BillListItemDTO): BillListItemEntity {
    return {
      bill_id: dto.bill_id,
      bill_number: dto.bill_number,
      currency_id: dto.currency_id,
      exchange_rate: dto.exchange_rate,
      vendor_id: dto.vendor_id,
      vendor_name: dto.vendor_name,
      total: dto.total,
      balance: dto.balance,
      tds_total: dto.tds_total,
      currency_code: dto.currency_code,
      currency_symbol: dto.currency_symbol,
      status: dto.status,
    };
  }

  static toResultEntity(dto: BillsResponseDTO): BillsResultEntity {
    return {
      items: dto.data.map((bill) => this.toEntity(bill)),
      pagination: dto.pagination as PaginationInfo,
    };
  }
}
